import Hero from './Hero'

export * from './Hero.types'

export default Hero
